import { Dispatch } from "redux";
import { resetFormValues, setSection } from "../CreateCertificateModalSlice";
import { SectionEnum } from "../../../common/enums/SectionEnum";

interface GetSectionsReturnType {
    title: string;
    onClick: () => void;
}

export const getSections = (dispatch: Dispatch): GetSectionsReturnType[] => {
    return [
        {
            title: "Persoonscertificaat",
            onClick: () => {
                dispatch(resetFormValues());
                dispatch(
                    setSection({
                        name: SectionEnum.PERSONS_CERTIFICATE,
                        activeIndex: 0,
                    }),
                );
            },
        },
        {
            title: "Vestigingscertificaat",
            onClick: () => {
                dispatch(resetFormValues());
                dispatch(
                    setSection({
                        name: SectionEnum.ESTABLISHMENTS_CERTIFICATE,
                        activeIndex: 1,
                    }),
                );
            },
        },
        {
            title: "Uitbesteed",
            onClick: () => {
                dispatch(resetFormValues());
                dispatch(
                    setSection({
                        name: SectionEnum.OUTSOURCED,
                        activeIndex: 2,
                    }),
                );
            },
        },
    ];
};
